import { Customer } from '@vfde-sails/login';
import { JarvisProducts } from '../../interface';
import { AppAction } from './enum';
import {
    AppError,
    AppState,
} from './interface';

/**
 * Loads initial state and triggers init sagas
 */
export const initStore = (state: Partial<AppState>) => ({
    type: AppAction.InitStore,
    state,
} as const);

/**
 * Sets the loading status for the id
 */
export const setLoading = (isLoading: boolean, id: string) => ({
    type: AppAction.SetLoading,
    isLoading,
    id,
} as const);

/**
 * Sets the given error into the state
 */
export const setError = (error: AppError) => ({
    type: AppAction.SetError,
    error,
} as const);

/**
 * Sets selected tariff ID
 */
export const setSelectedTariffId = (selectedTariffId: string) => ({
    type: AppAction.SetSelectedTariffId,
    selectedTariffId,
} as const);

/**
 * Sets loaded Jarvis tariffs
 */
export const setTariffs = (tariffs: JarvisProducts) => ({
    type: AppAction.SetTariffs,
    tariffs,
} as const);

/**
 * Sets customer if logged in
 */
export const setCustomer = (customer?: Customer) => ({
    type: AppAction.SetCustomer,
    customer,
} as const);

/**
 * Type for all actions
 */
export type Actions = ReturnType<typeof initStore>
    | ReturnType<typeof setLoading>
    | ReturnType<typeof setError>
    | ReturnType<typeof setSelectedTariffId>
    | ReturnType<typeof setCustomer>
    | ReturnType<typeof setTariffs>;
